
import { combineReducers } from 'redux'
import customerDataReducer from './customer/CustomerData'
import service from './service/service'
import task from './service/task'
import taskDetails from './service/taskDetails'
import loading from './service/loading'
import guaranteeCardsReducer from './guaranteeCards/GuaranteeCardsData'
import locationDataReducer from './location/locationData';
import popup from "./Common/popup";
import happycallDataReducer from "./service/HappyCallData";
import ProductRequestReducer from "./ProductRequest/ProductRequestForService";
import UserReducer from "./UsersData";
import SystemSettingsReducer from './Common/SystemSettings';
import ProductReducer from "./Common/ProductReducer";
import CommandsReducer from './Common/CommandsReducer';
import StaffReducer from './StaffReducer';

const reducers = combineReducers({
  customerDataReducer,
  service,
  task,
  taskDetails,
  loading,
  guaranteeCardsReducer,
  locationDataReducer,
  happycallDataReducer,
  popup,
  ProductRequestReducer,
  UserReducer,
  SystemSettingsReducer,
  ProductReducer,
  CommandsReducer,
  StaffReducer
})


export default reducers;